const swaggerUrlApi = 'https://virtserver.swaggerhub.com/C6627/Admin-cabinet-api/1.0.0'
const devservUrlApi = 'https://insideapi.cardpr.com/api'

const apiUrl = process.env.VUE_APP_API === 'swagger' ? swaggerUrlApi : devservUrlApi

export const API_PORT = '5000'
export const API_URL = apiUrl
export const DOMAIN_TITLE = 'Административный кабинет CARDPR'
export const SENTRY_DSN = 'https://1134e39cb16046b899d1f78e81f245bc@o314535.ingest.sentry.io/5808350'

export const DEPLOY_BRANCH = 'master'
